module.exports = __webpack_public_path__ + "img/screen3.5aa261ee.png";